export default "__VITE_ASSET__f9933b8c__"